

import React, { useContext } from "react";
import { Link } from "react-router-dom";
import {
  Wallet,
  Plus,
  History,
  ShieldCheck,
  ChevronRight,
  Landmark,
  BadgeCheck,
  TrendingUp,
  CircleDollarSign,
  Sparkles,
  ArrowUpRight
} from "lucide-react";
import { LanguageContext } from "../Components/LanguageContext";
import Rightcontainer from "../Components/Rightcontainer";
// import "./Mywallet.css";

const Mywallet = ({ user }) => {
  const { language } = useContext(LanguageContext);

  const translations = {
    hi: {
      wallet: "वॉलेट बैलेंस",
      secure: "MPLBETS सुरक्षित कैश",
      available: "कुल उपलब्ध शेष",
      deposit: "डिपॉजिट",
      winnings: "विनिंग्स",
      history: "ट्रांजैक्शन हिस्ट्री",
      add: "कैश जोड़ें",
      withdraw: "पैसे निकालें",
      verified: "वेरिफाइड",
      encrypted: "256-बिट सुरक्षित एन्क्रिप्टेड गेटवे",
    },
    en: {
      wallet: "Wallet Balance",
      secure: "MPLBETS Secure Cash",
      available: "AVAILABLE BALANCE",
      deposit: "Deposit",
      winnings: "Winnings",
      history: "Transaction History",
      add: "ADD CASH",
      withdraw: "WITHDRAW MONEY",
      verified: "Verified",
      encrypted: "256-BIT SECURE ENCRYPTED GATEWAY",
    },
  };

  const t = translations[language] || translations.en;

  // Safe formatting helpers
  const totalBalance = Number(user?.Wallet_balance || 0);
  const winningsBalance = Number(user?.withdrawAmount || 0);
  const depositBalance = Math.max(0, totalBalance - winningsBalance);

  return (
    <div className="sa-wallet-wrapper leftContainer mt-5 pt-5">
      {/* Background Ambient Lights */}
      <div className="wallet-ambient glow-1"></div>
      <div className="wallet-ambient glow-2"></div>
      <div className="wallet-ambient glow-3"></div>

      <div className="sa-wallet-container mb-5">
        
        {/* Top Header Card */}
        <div className="sa-header-card">
          <div className="sa-header-content">
            <div className="sa-badge-pill">
              <Sparkles size={14} className="sparkle-icon" />
              <span style={{color:"#000"}}>{t.secure}</span>
            </div>
            <h1 className="sa-title">{t.wallet}</h1>
          </div>
          <div className="sa-wallet-icon-badge">
            <Wallet size={26} />
          </div>
        </div>

        {/* Hero Balance Card */}
        <div className="sa-hero-card">
          <div className="sa-card-bg-glow"></div>
          <div className="sa-card-pattern"></div>

          <div className="sa-hero-top">
            <span className="sa-hero-label">{t.available}</span>
            <div className="sa-verified-pill">
              <BadgeCheck size={16} />
              <span>{t.verified}</span>
            </div>
          </div>

          <div className="sa-hero-amount">
            <span className="sa-currency">₹</span>
            <span className="sa-amount-digits">{totalBalance.toFixed(2)}</span>
          </div>

          <div className="sa-hero-footer">
            <div className="sa-quick-pill">
              <span className="pill-dot green"></span>
              <span>Deposit: ₹{depositBalance.toFixed(0)}</span>
            </div>
            <div className="sa-quick-pill gold">
              <span className="pill-dot gold"></span>
              <span>Winnings: ₹{winningsBalance.toFixed(0)}</span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="sa-actions-wrapper">
          <Link to="/addcase" className="sa-action-btn sa-btn-add">
            <div className="sa-btn-glow"></div>
            <div className="sa-btn-content">
              <div className="sa-icon-circle">
                <Plus size={20} />
              </div>
              <span className="sa-btn-text">{t.add}</span>
            </div>
            <ArrowUpRight size={18} className="sa-btn-arrow" />
          </Link>

          <Link to="/Withdrawopt" className="sa-action-btn sa-btn-withdraw">
            <div className="sa-btn-glow"></div>
            <div className="sa-btn-content">
              <div className="sa-icon-circle cyan">
                <Landmark size={20} />
              </div>
              <span className="sa-btn-text">{t.withdraw}</span>
            </div>
            <ArrowUpRight size={18} className="sa-btn-arrow" />
          </Link>
        </div>

        {/* Detailed Breakdown Cards */}
        <div className="sa-metrics-grid">
          {/* <div className="sa-metric-card deposit">
            <div className="sa-metric-header">
              <div className="sa-metric-icon-box green">
                <CircleDollarSign size={18} />
              </div>
              <span className="sa-metric-label">{t.deposit}</span>
            </div>
            <div className="sa-metric-value">₹{depositBalance.toFixed(2)}</div>
          </div> */}

          {/* <div className="sa-metric-card winnings">
            <div className="sa-metric-header">
              <div className="sa-metric-icon-box gold">
                <TrendingUp size={18} />
              </div>
              <span className="sa-metric-label gold">{t.winnings}</span>
            </div>
            <div className="sa-metric-value gold">₹{winningsBalance.toFixed(2)}</div>
          </div> */}
        </div>

        {/* Transaction History Banner */}
        <Link to="/history" className="sa-history-banner">
          <div className="sa-history-info">
            <div className="sa-history-icon-box">
              <History size={20} />
            </div>
            <div className="sa-history-details">
              <span className="sa-history-title">{t.history}</span>
              <span className="sa-history-sub">View recent deposits & cashouts</span>
            </div>
          </div>
          <div className="sa-history-arrow-box">
            <ChevronRight size={20} />
          </div>
        </Link>

        {/* Security Footer */}
        <div className="sa-security-footer">
          <ShieldCheck size={18} className="shield-icon" />
          <span>{t.encrypted}</span>
        </div>

      </div>

      <div className="rightContainer mobile-hide">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Mywallet;